import first from './first.jpg'
import four from './four.jpg'

export default [first, four]